import React, { useState } from 'react'
import { Mutation } from 'react-apollo'
import moment from 'moment'
import _ from 'lodash'
import { useMutation } from '@apollo/react-hooks'
import { Link } from 'react-router-dom'
import {
  message, Modal, DatePicker, Select, Icon, Menu, Dropdown, Button, Row, Col,
} from 'antd'
import {
  SmallText, Div, H4, Button as KonsysButton, Input,
} from 'konsys-ui'
import { UPDATE_DRIVER } from '../../constants/graphql/mutation'
import { CREATE_LEAVE, CREATE_PURCHASE_ORDER } from '../../constants/graph/mutation'
// TODO: Add CREATE_DRIVER_LEAVE mutation to constants/graphql/mutation.js
import { DRIVER_LIST } from '../../constants/graphql/query'
import history from '../../history'
import { theme } from '../../styles/_variables'
import { status, statusText } from '../../pages/driver-page/constants'
import { P } from '../../pages/driver-page/styled'
import { checkFloat, monthConverter } from '../../utils/util-services'
import PERMISSION from '../../constants/permissions'

const { color } = theme

export const CellText = props => (
  <P font='sarabun' padding='3px' {...props}>{props.children}</P>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange, value }) => (
  <input placeholder='ค้นหา' onChange={e => handleChange(e.target.value)} value={value} />
)

export const StatusSelector = ({
  handleChange, filter, disabled,
}) => {
  const arr = [
    { value: status.OLD, text: statusText.OLD },
    { value: status.NEWS, text: statusText.NEWS },
    { value: status.LICENSE_EXPIRED, text: statusText.LICENSE_EXPIRED },
    { value: status.LEAVE, text: statusText.LEAVE },
  ]

  const filterer = filter ? _.concat({ value: 'ALL', text: 'ทั้งหมด' }, arr) : arr

  return (
    <Select
      disabled={disabled}
      dropdown
      style={{ width: 130 }}
      defaultValue="ปกติ"
      onChange={e => handleChange(e)}
    >
      {
        filterer.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
      }
    </Select>
  )
}

const SalaryModal = ({
  salaryModal, setSalaryModal,
}) => {
  const [date, setDate] = useState()
  const [period, setPeriod] = useState('')
  const [bonus, setBonus] = useState(0)
  const [penalty, setPenalty] = useState(0)
  const [doAction, { loading: mutationLoading }] = useMutation(CREATE_PURCHASE_ORDER)
  return (
    <Modal
      title="บันทึกรายได้/ส่วนหักเงินเดือน"
      visible={salaryModal}
      destroyOnClose={true}
      onCancel={() => {
        setSalaryModal(false)
        setDate()
      }}
      onOk={() => {
        doAction({
          variables: {
            date,
          },
        }).then((resp) => {
          const KEY = ''
          if (resp.data[KEY].success) {
            message.success(resp.data[KEY].message)
            history.push('/driver')
          } else message.error(resp.data[KEY].message)
        })
      }}
      okButtonProps={{
        disabled: mutationLoading,
        loading: mutationLoading,
      }}
      cancelButtonProps={{
        disabled: mutationLoading,
      }}
    >
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='row'>
        <P margin='16px 0'>เลือกเดือน</P>
        <DatePicker.MonthPicker
          placeholder='เลือกเดือน'
          style={{ width: '334px' }}
          format='DD/MM/YYYY'
          onChange={(e) => {
            setDate(moment(e).startOf('month'))
          }}
        />
      </Div>
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='row'>
        <P margin='16px 0'>เลือก งวด</P>
        <Select
          style={{ width: 334 }}
          onSelect={(e) => {
            setPeriod(e)
          }}
        >
          <Select.Option key='1' value='1'>1</Select.Option>
          <Select.Option key='2' value='2'>2</Select.Option>
        </Select>
      </Div>
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='row'>
        <P margin='16px 0'>เงินเดือน</P>
        <Input
          width='334px'
          type='number'
          step={0.1}
          min={0}
          disabled={true}
          onKeyDown={(e) => {
            if (!checkFloat(e)) {
              e.preventDefault()
            }
          }}
        />
      </Div>
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='row'>
        <P margin='16px 0'>รายได้พิเศษ</P>
        <Input
          width='334px'
          type='number'
          step={0.1}
          min={0}
          onKeyDown={(e) => {
            if (!checkFloat(e)) {
              e.preventDefault()
            }
          }}
          onChange={e => setBonus(e.target.value)}
        />
      </Div>
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='row'>
        <P margin='16px 0'>ส่วนหัก</P>
        <Input
          width='334px'
          type='number'
          step={0.1}
          min={0}
          onKeyDown={(e) => {
            if (!checkFloat(e)) {
              e.preventDefault()
            }
          }}
          onChange={e => setPenalty(e.target.value)}
        />
      </Div>
    </Modal>
  )
}

export const PaymentActionBar = ({
  loading, doAction, mutationVariables, props, disabled,
}) => {
  const [modal, setModal] = useState(false)
  return (
    <Div
      position='fixed'
      height='72px'
      bottom='0'
      left='0'
      right='0'
      style={{ background: `${color.primaryColor}33` }}
      display='flex'
      justifyContent='flex-end'
      alignItems='center'
      padding='0 32px 0 0'
    >
      <KonsysButton
        loading={loading}
        disabled={loading || !_.includes(window.perms, PERMISSION.CREATE_SALARY) || disabled}
        text='บันทึก'
        icon='fas fa-plus'
        inverse
        onClick={() => {
          doAction({
            variables: {
              ...mutationVariables,
            },
          }).then(({ data }) => {
            const resp = data.CreateDriverSalary
            if (resp.success) {
              message.success(resp.message)
              history.push('/driver')
            } else message.error(resp.message)
          })
        }}
      />
    </Div>
  )
}

const LeaveModal = ({
 leaveModal, setLeaveModal, original, refetch,
}) => {
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [leaveReason, setLeaveReason] = useState('')
  const [createLeave, { loading: createLeaveLoading }] = useMutation(CREATE_LEAVE)
  const [loading, setLoading] = useState(false)

  const disabledDate = current => current && current.isBefore(moment().startOf('day'))

  // Calculate total leave days including weekends
  const calculateTotalDays = () => {
    if (!startDate || !endDate) return 0
    const start = moment(startDate)
    const end = moment(endDate)
    if (end.isBefore(start)) return 0
    return end.diff(start, 'days') + 1
  }

  const totalDays = calculateTotalDays()

  const handleSubmit = async () => {
    if (!startDate || !endDate || !leaveReason.trim()) {
      message.error('กรุณากรอกข้อมูลให้ครบถ้วน')
      return
    }

    if (moment(endDate).isBefore(moment(startDate))) {
      message.error('วันที่สิ้นสุดต้องไม่น้อยกว่าวันที่เริ่มลา')
      return
    }

    setLoading(true)
    try {
      await createLeave({
        variables: {
          driverId: original.id,
          startDate: moment(startDate).format('YYYY-MM-DD'),
          endDate: moment(endDate).format('YYYY-MM-DD'),
          remark: leaveReason,
        },
      }).then(({ data }) => {
        const response = data.CreateLeave
        if (response.success) {
          message.success('สร้างการลาสำเร็จ')
          setLeaveModal(false)
          setLeaveReason('')
          setStartDate()
          setEndDate()
          refetch()
        } else message.error(response.message)
      })
    } catch (error) {
      message.error('เกิดข้อผิดพลาดในการสร้างการลา')
    } finally {
      setLoading(false)
    }
  }

  const handleCancel = () => {
    setLeaveModal(false)
    setLeaveReason('')
    setStartDate()
    setEndDate()
  }

  return (
    <Modal
      title="สร้างการลา"
      visible={leaveModal}
      onCancel={handleCancel}
      onOk={handleSubmit}
      okText="สร้างวันลา"
      cancelText="ยกเลิก"
      okButtonProps={{
        disabled: loading || !startDate || !endDate || !leaveReason.trim(),
        loading: loading || createLeaveLoading,
      }}
      cancelButtonProps={{
        disabled: loading || createLeaveLoading,
      }}
      width={500}
    >
      <div className="font-inter space-y-4">
        {/* Start Date */}
        <div className="flex items-center">
          <p className="m-0 min-w-[120px] font-inter">วันที่เริ่มลา:</p>
          <div className="flex items-center w-full">
            <DatePicker
              style={{ width: '100%' }}
              format="DD/MM/YYYY"
              value={startDate}
              disabledDate={disabledDate}
              onChange={date => setStartDate(date)}
              placeholder="เลือกวันที่เริ่มลา"
            />
          </div>
        </div>

        {/* End Date */}
        <div className="flex items-center">
          <p className="m-0 min-w-[120px] font-inter">วันที่สิ้นสุด:</p>
          <div className="flex items-center w-full">
            <DatePicker
              style={{ width: '100%' }}
              format="DD/MM/YYYY"
              value={endDate}
              disabledDate={disabledDate}
              onChange={date => setEndDate(date)}
              placeholder="เลือกวันที่สิ้นสุด"
            />
          </div>
        </div>

        {/* Total Leave Days */}
        <div className="flex items-center">
          <p className="m-0 min-w-[120px] font-inter">รวมวันลา:</p>
          <p className="m-0 text-gray-500 font-bold font-inter">
            {totalDays} วัน (รวมวันหยุด)
          </p>
        </div>
        <hr className='text-gray-200' />
        {/* Leave Reason */}
        <div className="flex justify-between">
          <p className="m-0 min-w-[120px] font-inter">หมายเหตุการลา:</p>
          <textarea
            rows={4}
            placeholder="ระบุเหตุผลในการลา"
            value={leaveReason}
            onChange={e => setLeaveReason(e.target.value)}
            className="w-full border border-gray-200 rounded px-3 py-2 font-inter"
          />
        </div>
      </div>
    </Modal>
  )
}

const FireModal = ({ fireModal, setFireModal, original }) => {
  const [quitDate, setQuitDate] = useState(moment())
  return (
    <Mutation
      mutation={UPDATE_DRIVER}
      refetchQueries={[{ query: DRIVER_LIST }]}
    >{(doChangeStatus, { loading }) => (
      <Modal
        title="ต้องการปลดพนักงาน?"
        visible={fireModal}
        onCancel={() => {
          setFireModal(false)
        }}
        onOk={() => {
          doChangeStatus({
            variables: {
              id: original.id,
              status: status.OLD,
              quitDate,
            },
          }).then((resp) => {
            const response = resp.data.UpdateDriver
            if (response.success) message.success(response.message)
            else message.error(response.message)
            setFireModal(false)
          })
        }}
        okButtonProps={{
          disabled: quitDate === 'Invalid date',
          loading,
        }}
      >
        <Div display='flex' justifyContent='space-between'>
          <H4>วันที่ออก: </H4>
          <DatePicker onChange={e => setQuitDate(moment(e).format('YYYY-MM-DD'))} defaultValue={quitDate} />
        </Div>
      </Modal>
    )}
    </Mutation>

  )
}

const menu = (original, setFireModal, setSalaryModal, setLeaveModal) => (
  <Div>
    <Menu onSelect={(e) => {
      if (e.key === 'quit') setFireModal(true)
      if (e.key === 'leave') setLeaveModal(true)
    }}
      selectedKeys={undefined}
    >
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_DRIVER)}>
        <Link target="_blank" to={`/driver/view/${original.id}`}>
          ดูรายละเอียด
              </Link>
      </Menu.Item>
      <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_DRIVER)}>
        <Link target="_blank" to={`/driver/edit/${original.id}`}>
          แก้ไข
              </Link>
      </Menu.Item>
      {
        _.includes(window.perms, PERMISSION.CREATE_SALARY)
        && <Menu.Item key='salary' disabled={!_.includes(window.perms, PERMISSION.CREATE_SALARY)}>
          <Link target="_blank" to={`/driver/salary/${original.id}`}>
            บันทึกรายได้/ส่วนหักเงินเดือน
          </Link>
        </Menu.Item>
      }
      {
        original.status !== status.OLD
        && <Menu.Item key='quit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_DRIVER)}>
          ออกจากงาน
              </Menu.Item>
      }
      <Menu.Item key='leave' disabled={!_.includes(window.perms, PERMISSION.UPDATE_DRIVER)}>
        ลางาน
      </Menu.Item>
    </Menu>
  </Div>
)

export const ActionSelector = ({ props: { original, refetch } }) => {
  const [fireModal, setFireModal] = useState(false)
  const [leaveModal, setLeaveModal] = useState(false)
  const [salaryModal, setSalaryModal] = useState(false)
  return (
    <Div>
      <Dropdown overlay={menu(original, setFireModal, setSalaryModal, setLeaveModal)} trigger='click'>
        <Button>
          ดูรายละเอียด <Icon type="down" />
        </Button>
      </Dropdown>
      {/* <SalaryModal
        salaryModal={salaryModal}
        setSalaryModal={setSalaryModal}
      /> */}
      <FireModal
        fireModal={fireModal}
        setFireModal={setFireModal}
        original={original}
      />
      <LeaveModal
        refetch={refetch}
        leaveModal={leaveModal}
        setLeaveModal={setLeaveModal}
        original={original}
      />
    </Div>
  )
}


export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const ActionBar = ({
  loading, isAddMode, isViewMode, doAction, mutationVariables, props, disabled,
}) => (
    <Div
      position='fixed'
      height='72px'
      bottom='0'
      left='0'
      right='0'
      style={{ background: `${color.primaryColor}33` }}
      display='flex'
      justifyContent='flex-end'
      alignItems='center'
      padding='0 32px 0 0'
    >
      <KonsysButton
        loading={loading}
        disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_DRIVER)) || disabled}
        text={isAddMode ? 'สร้างใหม่' : isViewMode ? 'แก้ไข' : 'บันทึก'}
        icon={isAddMode ? 'fas fa-plus' : isViewMode ? 'fas fa-edit' : 'fas fa-save'}
        inverse
        onClick={() => {
          if (isViewMode) history.push(`/driver/edit/${props.match.params.id}`)
          else {
            doAction({
              variables: isAddMode ? { ...mutationVariables } : { id: parseInt(props.match.params.id, 10), ...mutationVariables },
            }).then(({ data }) => {
              const resp = isAddMode ? data.CreateDriver : data.UpdateDriver

              if (resp.success) {
                message.success(resp.message)
                if (isAddMode) history.push('/driver')
                // else history.push(`/driver/view/${props.match.params.id}`)
              } else message.error(resp.message)
            })
          }
        }}
      />
    </Div>
)

export const DriverLog = ({ data }) => (
  <Div style={{ borderBottom: `1px solid ${color.paleGrey}` }}>
    <Row type='flex' justify="center" gutter={4} style={{ margin: '32px 0' }}>
      <Col span={3} style={{ textAlign: 'center' }}><P bold>วันที่ถูกหัก</P></Col>
      <Col span={2} style={{ textAlign: 'center' }}><P bold>เล่มที่</P></Col>
      <Col span={2} style={{ textAlign: 'center' }}><P bold>เลขที่</P></Col>
      <Col span={4} style={{ textAlign: 'center' }}><P bold>ถูกหักครั้งต่อไป (ลิตร)</P></Col>
      <Col span={3} style={{ textAlign: 'center' }}><P bold>ถูกหักเบี้ยเลี้ยง</P></Col>
    </Row>
    {
      _.map(data, v => <Row type='flex' justify="center">
        <Col span={3} style={{ margin: '0 0 16px', textAlign: 'center' }}><P>{_.isEmpty(v.createdAt) ? '-' : moment(v.createdAt).format('DD/MM/YYYY')}</P></Col>
        <Col span={2} style={{ margin: '0 0 16px', textAlign: 'center' }}><P>{_.isEmpty(v.volumn) ? '-' : v.volumn}</P></Col>
        <Col span={2} style={{ margin: '0 0 16px', textAlign: 'center' }}><P>{_.isEmpty(v.number) ? '-' : v.number}</P></Col>
        <Col span={4} style={{ margin: '0 0 16px', textAlign: 'center' }}><P>{_.isNull(v.totalAmount) ? '-' : v.totalAmount}</P></Col>
        <Col span={3} style={{ margin: '0 0 16px', textAlign: 'center' }}><P>{_.isNull(v.totalDeduct) ? '-' : v.totalDeduct}</P></Col>
      </Row>)
    }
  </Div>
)
